import { Injectable } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';

type NotificationType = 'success' | 'error';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private readonly _toast: HotToastService) { }

    notify(message: string, type?: NotificationType): void {
        const resolvedType = type ?? this._inferType(message);
        if (resolvedType === 'error') {
            this.notifyError(message);
            return;
        }

        this.notifySuccess(message);
    }

    notifySuccess(message: string): void {
        this._toast.success(message, {
            duration: 5000,
            style: {
                border: '1px solid #04b746',
                padding: '16px',
                background: '#04b746',
                color: '#fff'
            },
            iconTheme: {
                primary: '#fff',
                secondary: '#04b746',
            },
        });
    }

    notifyError(message: string): void {
        this._toast.error(message, {
            duration: 5000,
            style: {
                border: '1px solid #dc2626',
                padding: '16px',
                background: '#dc2626',
                color: '#fff'
            },
            icon: '✕',
            iconTheme: {
                primary: '#fff',
                secondary: '#dc2626',
            },
        });
    }

    private _inferType(message: string): NotificationType {
        const normalized = (message || '').toLowerCase();
        const errorSignals = [
            'error',
            'failed',
            'invalid',
            'missing',
            'unauthorized',
            'not found',
            'try again',
            'unable',
            'exceeded',
            'denied'
        ];

        return errorSignals.some((signal) => normalized.includes(signal)) ? 'error' : 'success';
    }
}
